/* eslint-disable max-len */
import { DATE_PUBLISHED, DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the date published filter
 * @param {string} datePublished - One of: "all_time", "last_24_hours", "last_7_days", "last_30_days", "last_6_months", "last_12_months", "custom"
 */
export const setDatePublished = (datePublished) => {
  // min/maxDatePublished may only exist while CUSTOM is selected: the calendar is hidden for
  // presets, yet getMainFiltersCount still counts a stale range the user can no longer reach.
  searchPageStore.setState(datePublished === DATE_PUBLISHED.CUSTOM
    ? { datePublished }
    : {
      datePublished,
      minDatePublished: DEFAULT_STATE.minDatePublished,
      maxDatePublished: DEFAULT_STATE.maxDatePublished,
    })
}

/**
 * Sets the minimum date published filter
 * @param {string|undefined} minDatePublished - Minimum date string or undefined
 */
export const setMinDatePublished = (minDatePublished) => {
  searchPageStore.setState({ minDatePublished })
}

/**
 * Sets the maximum date published filter
 * @param {string|undefined} maxDatePublished - Maximum date string or undefined
 */
export const setMaxDatePublished = (maxDatePublished) => {
  searchPageStore.setState({ maxDatePublished })
}

/**
 * Clears all date-related filters
 */
export const clearDatePublished = () => {
  searchPageStore.setState({
    datePublished: DEFAULT_STATE.datePublished,
    minDatePublished: DEFAULT_STATE.minDatePublished,
    maxDatePublished: DEFAULT_STATE.maxDatePublished,
  })
}
